module.exports = __webpack_public_path__ + "img/vasset.f1455fee.webp";